import { render, staticRenderFns } from "./TaskError.vue?vue&type=template&id=f2c32068&"
import script from "./TaskError.vue?vue&type=script&lang=ts&"
export * from "./TaskError.vue?vue&type=script&lang=ts&"
import style0 from "./TaskError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
